import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const Share = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      fill="currentColor"
      d="m13.12 17.02-4.2-2.29a4 4 0 1 1 0-5.46l4.2-2.3a4 4 0 1 1 .96 1.76l-4.2 2.3a4 4 0 0 1 0 1.95l4.2 2.29a4 4 0 1 1-.96 1.75ZM6 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm11-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
    />
  </svg>
));
